const initMarqueeSwipers = () => {
  const sliders = document.querySelectorAll('.block__marquee-text-slider.swiper:not(.swiper-initialized)');
  sliders.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      speed: 7000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      allowTouchMove: false,
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMarqueeSwipers);
} else {
  initMarqueeSwipers();
}
document.addEventListener('shopify:section:load', initMarqueeSwipers);
